import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import {
  getAllPermissions,
  getAllPermissionsByRole,
} from '../../../../../api/user/list-all-permissions'
import { getAllApplications } from '../../../../../api/user/list-all-applications'

const initialState = {
  isFetchingPermissionsByApp: false,
  isFetchingApplications: false,
  isFetchingPermissionsByRole: false,
  permissionsByApp: [],
  roleApplication: [],
  permissionsByRole: [],
  fetchPermissionsError: null,
  fetchApplicationsError: null,
  fetchPermissionsByRoleError: null,
}

export const fetchPermissions = createAsyncThunk(
  'permissionsList/fetchPermissions',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getAllPermissions(args)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const fetchRoleApplication = createAsyncThunk(
  'permissionsList/application',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getAllApplications()
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const fetchPermissionsByRole = createAsyncThunk(
  'permissionsList/fetchPermissionsByRole',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getAllPermissionsByRole(args)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const permissionsListSlice = createSlice({
  name: 'viewPermissions',
  initialState,
  reducers: {
    resetPermissionsListSlice: () => {
      return initialState
    },
    resetFetchPermissionsError: (state) => {
      state.fetchPermissionsError = null
    },
    resetFetchApplicationsError: (state) => {
      state.fetchApplicationsError = null
    },
    resetFetchPermissionsByRoleError: (state) => {
      state.fetchPermissionsByRoleError = null
    },
  },
  extraReducers: (builder) => {
    builder
      /* Fetching Permissions */
      .addCase(fetchPermissions.pending, (state) => {
        state.isFetchingPermissionsByApp = true
        state.permissionsByApp = []
        state.fetchPermissionsError = null
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.isFetchingPermissionsByApp = false
        state.permissionsByApp = action.payload
        state.fetchPermissionsError = null
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.isFetchingPermissionsByApp = false
        state.fetchPermissionsError = action.payload
      })
      /* Fetching Applications */
      .addCase(fetchRoleApplication.pending, (state) => {
        state.isFetchingApplications = true
        state.roleApplication = []
        state.fetchApplicationsError = null
      })
      .addCase(fetchRoleApplication.fulfilled, (state, action) => {
        state.isFetchingApplications = false
        state.roleApplication = action.payload
        state.fetchApplicationsError = null
      })
      .addCase(fetchRoleApplication.rejected, (state, action) => {
        state.isFetchingApplications = false
        state.fetchApplicationsError = action.payload
      })
      /* Fetching Permissions By Role */
      .addCase(fetchPermissionsByRole.pending, (state) => {
        state.isFetchingPermissionsByRole = true
        state.permissionsByRole = []
        state.fetchPermissionsByRoleError = null
      })
      .addCase(fetchPermissionsByRole.fulfilled, (state, action) => {
        state.isFetchingPermissionsByRole = false
        state.permissionsByRole = action.payload
        state.fetchPermissionsByRoleError = null
      })
      .addCase(fetchPermissionsByRole.rejected, (state, action) => {
        state.isFetchingPermissionsByRole = false
        state.fetchPermissionsByRoleError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const {
  resetPermissionsListSlice,
  resetFetchPermissionsError,
  resetFetchApplicationsError,
  resetFetchPermissionsByRoleError,
} = permissionsListSlice.actions

export default permissionsListSlice.reducer
